// extracted by mini-css-extract-plugin
export default {"link":"MenuItem_link__ikA6f","active":"MenuItem_active__B2ukn","underline":"MenuItem_underline__YLE28","example":"MenuItem_example__I6-T5"};